// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__LtGas","title":"Form_title__3wSw6","defaultInput":"Form_defaultInput__3Kjna","button":"Form_button__1GncW"};